import React, { useState } from 'react';
import { ClickAwayListener, MenuItem, Button, MenuList, Popper, ListItemText, Paper } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons';
import { translate } from 'react-i18next';
import './shiftCardButtonActionMenu.scss';

const ShiftCardButtonActionMenu = ({
    t,
    isAsyncTaskProcessing,
    onSetJobTransfer,
    onSetSkillAndCertificationProfiles,
}) => {
    const [anchorEl, setAnchorEl] = useState('');
    const [openActionMenu, setOpenActionMenu] = useState(false);

    const onSetJobTransferClick = () => {
        setOpenActionMenu(!openActionMenu);
        onSetJobTransfer();
    }

    const onSetSkillAndCertificationProfilesClick = () => {
        setOpenActionMenu(!openActionMenu);
        onSetSkillAndCertificationProfiles();
    }

    const handleOpen = (event) => {
        event.stopPropagation()
        setOpenActionMenu(true);
        setAnchorEl(event.currentTarget)
    }
    
    return (
        <React.Fragment>
            <span
                className={'elipse'}
                onClick={(event) => handleOpen(event)}>
                <Button className='shiftCardButtonActionMenu'
                >
                    {<FontAwesomeIcon style={{ width: '0.725em' }} icon={faEllipsisH} />}
                </Button>
            </span>
            <Popper
                open={openActionMenu}
                placement={'bottom-start'}
                transition
                anchorEl={anchorEl}
            >
                <Paper>
                    <ClickAwayListener onClickAway={() => setOpenActionMenu(!openActionMenu)}>
                        <MenuList>
                            <MenuItem 
                                disabled={isAsyncTaskProcessing}
                            >
                                <ListItemText onClick={onSetJobTransferClick}>
                                    {t('workPlan.setJobTransfer')}
                                </ListItemText>
                            </MenuItem>
                            <MenuItem 
                                disabled={isAsyncTaskProcessing}
                            >
                                <ListItemText onClick={onSetSkillAndCertificationProfilesClick}>
                                    {t('workPlan.setSkillAndCertificationProfiles')}
                                </ListItemText>
                            </MenuItem>
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        </React.Fragment >
    )
}
export default React.memo(translate('workplanManager')(ShiftCardButtonActionMenu));
